import React from 'react';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import { BugReport, ContactPage, Edit } from '@mui/icons-material';
import { IBuildDocumentation } from '../../../models';

interface DocumentStatusIconsProps {
  buildDocumentation: IBuildDocumentation;
  showEditButton?: boolean;
  onEdit?: () => void;
}

export const DocumentStatusIcons: React.FC<DocumentStatusIconsProps> = ({
  buildDocumentation,
  showEditButton = false,
  onEdit
}) => {
  const { hasTermiteLetter, hasCertificateOfOccupancy } = buildDocumentation;

  return (
    <Box display="flex" alignItems="center">
      <Tooltip title={`Termite Letter - ${hasTermiteLetter ? 'Uploaded' : 'Required'}`}>
        <Box>
          <BugReport
            sx={{
              color: hasTermiteLetter ? 'secondary.main' : 'grey.400',
              mr: 0.5
            }}
          />
        </Box>
      </Tooltip>
      <Tooltip
        title={`Certificate of Occupancy - ${hasCertificateOfOccupancy ? 'Uploaded' : 'Required'}`}
      >
        <Box>
          <ContactPage
            sx={{
              color: hasCertificateOfOccupancy ? 'secondary.main' : 'grey.400',
              mr: showEditButton ? 0.5 : 0
            }}
          />
        </Box>
      </Tooltip>
      {showEditButton && (
        <>
          <Typography variant="body2" sx={{ mx: 1, color: 'text.secondary' }}>
            |
          </Typography>
          <IconButton color="primary" title="Edit Contract" onClick={onEdit}>
            <Edit />
          </IconButton>
        </>
      )}
    </Box>
  );
};
